import React, { useState, useEffect, useMemo } from "react"

import Rem_filter_page from "../layout/header";
import axios from "axios";
import * as path from 'path';
//const path = require('path');




import { CopyToClipboard } from "react-copy-to-clipboard";
function get_phone(data) {
    try {

        return JSON.parse(data);
    } catch (e) {
        // console.log(address);
        return [data];
    }
}
function print_company_description() {
    return (
        <div className="content" dangerouslySetInnerHTML={{ __html: window.post_content_data.replace(/&nbsp;/g, '<br />') }}></div>
    );
}

function get_more_data(data) {
    try {
        return JSON.parse(data);
    } catch (e) {
        // console.log(address);
        return [data];
    }
}
function Bussiness_cardsection(props) {
    var trader_review_qr = "data:image/svg+xml;base64," + props?.encode_url;

    console.log(props?.trader_qr_url);
    return (<div class="container trader">

        <div class="row">
            <div class="col-md-12 px-4">
                {(props?.photo) ?
                    <div class="top_img"><img src={(props?.photo) ? props?.photo : ''} class="img-fluid box-img" alt="..." /></div>
                    : <div class="top_img"> <img src={props.site_url + "/wp-content/uploads/2023/05/upimg.jpg"} class="img-fluid box-img" alt="..." /></div>
                }

                <div class="blue_box">
                    {(props?.MetaData?.rem_b_trader_name && props?.MetaData?.rem_b_trader_name[0] != '') ?
                        <h3>{props?.MetaData?.rem_b_trader_name[0]}</h3>
                        : ''
                    }
                    {(props?.MetaData?.rem_b_trader_title && props?.MetaData?.rem_b_trader_title[0] != '') ?
                        <p>{props?.MetaData?.rem_b_trader_title[0]}</p>
                        : ''
                    }
                </div>
                <input type="hidden" value={props?.data?.ID} id="post_id_get"></input>
                {/* <a href={props?.theme_dir + '/trader_cards/' + props?.data?.post_title + "trader.vcf"} download><i class="far fa-address-card"></i> Download Vcard</a> */}
                {(props?.MetaData?.rem_b_trader_name && props?.MetaData?.rem_b_trader_name[0] != '') ?
                    <button type="button" class="btn btn-lg btn-block btn-color" id="trader_vcf_dile_donload" post_id={props?.data?.ID}>+ Προσθήκη στις επαφές</button>
                    : ''
                }
                <h5>ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ</h5>

            </div>
            <div class="col-md-12 p-0">
                <ul class="list-group list-group-flush">
                    {(props?.MetaData?.rem_bussiness_mobile_no && props?.MetaData?.rem_bussiness_mobile_no[0] != '') ? get_phone(props?.MetaData?.rem_bussiness_mobile_no).map(function (mobile_no, i) {
                        // if (i == 0) {
                        return (<li><p class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            <a class="bussiness_tag_data" href={(mobile_no) ? 'tel:' + mobile_no : '#'}><div class="flex-column">
                                <img src={props.site_url + '/wp-content/uploads/2023/06/iphone-02.svg'} class="img-fluid" alt="...." />

                                {mobile_no}
                            </div></a>
                            <div class="image-parent" >
                                <img src={props.site_url + '/wp-content/uploads/2023/06/message.svg'} class="img-fluid" alt="...." />
                                <img onClick={() => {
                                    navigator.clipboard.writeText(mobile_no);
                                }} src={props.site_url + '/wp-content/uploads/2023/06/Icon-1.svg'} class="img-fluid copy_card_data" alt="...." />
                            </div>
                        </p>  </li>);
                        // }
                    }) : ''}

                    {(props?.MetaData?.rem_bussiness_phone_no && props?.MetaData?.rem_bussiness_phone_no[0] != '') ? get_phone(props?.MetaData?.rem_bussiness_phone_no).map(function (phone, i) {
                        // if (i == 0) {
                        return (<li><p class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            <a class="bussiness_tag_data" href={(phone) ? 'tel:' + phone : '#'}><div class="flex-column">
                                <img src={props.site_url + '/wp-content/uploads/2023/06/phone-call.svg'} class="img-fluid" alt="...." />
                                {phone}
                            </div></a>
                            <div class="image-parent">

                                <img onClick={() => {
                                    navigator.clipboard.writeText(phone);
                                }} src={props.site_url + '/wp-content/uploads/2023/06/Icon-1.svg'} class="img-fluid copy_card_data" alt="...." />
                            </div>
                        </p></li>);
                        // }
                    }) : ''}


                    {(props?.MetaData?.rem_bussiness_email_id && props?.MetaData?.rem_bussiness_email_id[0] != '') ? get_more_data(props?.MetaData?.rem_bussiness_email_id).map(function (email, i) {
                        // if (i == 0) {
                        return (<li><p class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            <a class="bussiness_tag_data" href={(email) ? 'mailto:' + email : '#'}><div class="flex-column">
                                <img src={props.site_url + '/wp-content/uploads/2023/06/mail.svg'} class="img-fluid" alt="...." />
                                {email}
                            </div>
                            </a>
                            <div class="image-parent">

                                <img onClick={() => {
                                    navigator.clipboard.writeText(email);
                                }} src={props.site_url + '/wp-content/uploads/2023/06/Icon-1.svg'} class="img-fluid copy_card_data" alt="...." />
                            </div>
                        </p></li>);
                        // }
                    }) : ''}


                    {(props?.MetaData?.rem_bussiness_website_url && props?.MetaData?.rem_bussiness_website_url[0] != '') ? get_more_data(props?.MetaData?.rem_bussiness_website_url).map(function (website, i) {
                        // if (i == 0) {
                        let domain = (new URL(website));
                        // domain = domain.hostname;
                        domain = domain.hostname.replace('www.', '');

                        return (<li><p target="_blank" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            <a class="bussiness_tag_data" href={(website) ? website : '#'}><div class="flex-column">
                                <img src={props.site_url + '/wp-content/uploads/2023/06/Iconlink.svg'} class="img-fluid" alt="...." />
                                {domain}
                            </div>
                            </a>
                            <div class="image-parent">

                                <img onClick={() => {
                                    navigator.clipboard.writeText(website);
                                }} src={props.site_url + '/wp-content/uploads/2023/06/Icon-1.svg'} class="img-fluid copy_card_data" alt="...." />
                            </div>
                        </p></li>);
                        // }
                    }) : ''}


                    {(props?.MetaData?.rem_bussiness_trader_address && props?.MetaData?.rem_bussiness_trader_address[0] != '') ? get_more_data(props?.MetaData?.rem_bussiness_trader_address).map(function (address, i) {
                        // if (i == 0) {
                        return (<li><p class="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                            <div class="d-flex address_sec">
                                <img src={props.site_url + '/wp-content/uploads/2023/06/map.svg'} class="img-fluid" alt="...." />
                                <span>{address}</span>
                            </div>
                            <div class="image-parent d-flex">
                                <img src={props.site_url + '/wp-content/uploads/2023/06/marker.svg'} class="img-fluid" alt="...." />
                                <img onClick={() => {
                                    navigator.clipboard.writeText(address);
                                }} src={props.site_url + '/wp-content/uploads/2023/06/Icon-1.svg'} class="img-fluid copy_card_data" alt="...." />
                            </div>
                        </p> </li>);
                        // }
                    }) : ''}

                    <li class="d-flex social-loop px-4 social-icon">
                        {(props?.MetaData?.rem_facebook && props?.MetaData?.rem_facebook != '') ?
                            <div class="">
                                <a href={(props?.MetaData?.rem_facebook) ? props?.MetaData?.rem_facebook[0] : '#'} target="_blank" ><i class="fab fa-facebook-square"></i></a>
                            </div>
                            : ''
                        }
                        {(props?.MetaData?.rem_instagram && props?.MetaData?.rem_instagram != '') ?
                            <div class=""><a href={(props?.MetaData?.rem_instagram) ? props?.MetaData?.rem_instagram[0] : '#'} target="_blank"><i class="fab fa-instagram-square"></i></a></div>
                            : ''
                        }
                        {(props?.MetaData?.rem_twitter && props?.MetaData?.rem_twitter != '') ?
                            <div class=""><a href={(props?.MetaData?.rem_twitter) ? props?.MetaData?.rem_twitter[0] : '#'} target="_blank"><i class="fab fa-twitter-square"></i></a></div>
                            : ''
                        }
                        {(props?.MetaData?.rem_linkedin && props?.MetaData?.rem_linkedin != '') ?
                            <div class=""><a href={(props?.MetaData?.rem_linkedin) ? props?.MetaData?.rem_linkedin[0] : '#'} target="_blank"><i class="fab fa-linkedin"></i></a></div>
                            : ''
                        }
                    </li>
                </ul>
            </div>
            {(props?.traderqr && props?.traderqre != '') ?
                <div class="col-md-12 px-4">
                    <h5 class="mr">SHARE CARD</h5>

                    <embed src={props?.traderqr} class="img-fluid qr-img" />
                </div>
                : ''
            }
            {console.log(props)}
            <div class="col-md-12 px-4">
                <h5 class="mr">ΤΡΟΠΟΙ ΕΠΙΚΟΙΝΩΝΙΑΣ</h5>
                <li class="d-flex">
                    {(props?.MetaData?.rem_bussiness_email_id && props?.MetaData?.rem_bussiness_email_id[0] != '') ? get_more_data(props?.MetaData?.rem_bussiness_email_id).map(function (email, i) {
                        if (i == 0) {
                            return (<div class="social-loop-inner  "><a href={(email) ? 'mailto:' + email : '#'}><i class="fas fa-envelope"></i></a></div>);
                        }
                    }) : ''}
                    {(props?.MetaData?.rem_bussiness_mobile_no && props?.MetaData?.rem_bussiness_mobile_no[0] != '') ? get_phone(props?.MetaData?.rem_bussiness_mobile_no).map(function (mobile_no, i) {
                        if (i == 0) {
                            return (<div class="social-loop-inner  "><a href={(mobile_no) ? 'sms:' + mobile_no : '#'}><i class="fas fa-pen"></i></a></div>);
                        }
                    }) : ''}
                    {/* <div class="social-loop-inner  "><a href="#"><i class="fab fa-whatsapp"></i></a></div> */}
                    {(props?.MetaData?.rem_bussiness_phone_no && props?.MetaData?.rem_bussiness_phone_no[0] != '') ? get_phone(props?.MetaData?.rem_bussiness_phone_no).map(function (phone, i) {
                        if (i == 0) {
                            return (<div class="social-loop-inner  "><a href={(phone) ? 'tel:' + phone : '#'}><i class="fas fa-mobile-alt"></i></a></div>);
                        }
                    }) : ''}
                </li>
            </div>
            <div class="col-md-12 px-4 for_us">
                {(props?.data?.post_content) ?
                    <h5 class="mr">ΓΙΑ ΕΜΑΣ</h5>
                    : ''
                }
                {(props?.data?.post_content) ?
                    <p >
                        {print_company_description()}
                    </p>
                    : ''
                }

            </div>
            {(props?.trader_qr_url && props?.trader_qr_url != '') ?
                <div class="col-md-12 px-4">
                    <h5 class="mr">ΑΦΗΣΤΕ ΤΗΝ ΑΞΙΟΛΟΓΗΣΗ ΣΑΣ</h5>
                    <div class="d-flex justify-content-around mb-5">
                        <div class="embed-section">
                            <a href={props?.qr_review}>
                                {/* <img id="qr_code" src={trader_review_qr} class="img-fluid qr-code" loading="lazy"></img> */}

                            </a>
                            <embed src={props?.trader_qr_url} class="img-fluid qr-img" />
                        </div>
                        <div class="scan_click">
                            Scan<br />
                            or<br />
                            Click
                        </div>
                    </div>
                </div>
                : ''
            }
        </div>
        {/* <div class="footer-top">
            <h5 class="mr">ΠΡΟΣΘΕΣΕ ΤΗ ΚΑΡΤΑ ΣΟΥ ΣΤΟ</h5>
            <div class="img-block">
                <div class="img-section-block">
                    <img src={props.site_url+'/wp-content/uploads/2023/06/GR_Add_to_Apple_Wallet_RGB_102121.svg'} alt="" />
                </div>
                <div class="img-section-block">

                    <img src={props.site_url +'/wp-content/uploads/2023/06/gr_add_to_google_wallet_add-wallet-badge.svg'} alt="" />
                </div>
            </div>
        </div> */}
        <div class="bottom-footer">
            <div class="footer-divider mr"></div>
            <a href={props.site_url}>
                <img src="https://tamastoria.gr/wp-content/uploads/2023/04/mastoria-logo.svg" />
            </a>
        </div>
    </div>


    );
}
export default Bussiness_cardsection;
